"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  statisticAnalysis: {
    statisticAnalysis: '统计分析',
    comprehensive: '综合统计',
    rentArrears: '租家欠款明细',
    ownedShip: '租入船/自有船',
    statisticalYear: '统计年份',
    searchType: '查询方式',
    searchTime: '查询时间',
    statistical: '统计时间',
    supFlag: '供应审核',
    trkFlag: '机务审核',
    voyageStartFrom: '航次时间',
    statisticalFrom: '统计时间从',
    statisticalFrom0: '统计时间',
    to: '到',
    fuelStatistics: '燃油统计',
    addingFuel: '加装燃油统计',
    monthlyRobCon: '月度燃油统计',
    monthlyLube: '月度滑油统计',
    stmcRpt: '速度吨海里油耗报表',
    fuelDetail: '燃油消耗统计表',
    fuelSaved: '船舶燃油节省统计',
    fuelConsumption: '燃油消耗统计(按完成航次)',
    fuelVoyageType: '燃油消耗(按航次类型)统计表',
    fuelVolAmount: '加油总量与金额统计表',
    topTenTenantsStatistics: '前十大租家统计表',
    topTenBrokerStatistics: '前十大经纪人统计表',
    topTenAgentStatistics: '前十大代理统计',
    rowNo: '排序',
    chartererNameEn: '租家名称',
    qtySum: '货运量',
    qtyPercent: '占总运量比例',
    qtySumVc: '航次数',
    qtyPercentVc: '占总航次比例',
    qtyIncome: '收入',
    qtyIncomePercent: '占总收入比例',
    qtyNum: '个数',
    qtyNumPercent: '占总个数比例',
    byQty: '按货量',
    byNetIncome: '按净收入',
    byTotalIncome: '按总收入',
    byVcVoyageNum: '按VC航次数',
    byPortCharges: '按港口使费',
    byAgencyFeeIncome: '按代理费收入',
    agentCount: '代理次数',
    agentName: '代理名称',
    usageAmount: '使费金额',
    proportionTotalAmount: '占总金额比例',
    agencyFeeIncome: '代理费收入',
    proportionTotalFrequency: '占总次数比例',
    voyageType: '类型',
    //账龄查询
    summaryByTenant: '按租家汇总',
    summaryByAging: '按账龄汇总',
    agingQuery: '账龄查询',
    queryByTenantGroup: '按租家分组查询',
    tenant: '租家',
    tenantName: '租家名称',
    shipping: '船舶',
    voyageNo: '航次',
    broker1NameEn: '经纪人',
    contractDate: '合同日期',
    invoiceNo: '发票号',
    invoiceDate: '发票日期',
    dueDate: '到期日',
    invoiceType: '发票类型',
    amount: '金额',
    aging: '账龄',
    creator: '创建人',
    approvedBy: '审批人',
    agingDate: '账龄日期',
    agingRange: '账龄区间',
    chargeType: '费用类型',
    operatingCompany: '经营公司',
    queryByShipGroup: '按船舶分组查询',
    //应收未收一览表
    queryReceivableItem: '应收未收一览表',
    currencyCode: '币别',
    invoiceAmount: '应收金额',
    commAmount: '佣金',
    byCommRevenue: '佣金收入',
    byFixtureOrder: 'Fixture Order',
    day30: '30天以内',
    day90: '31-90天',
    day180: '91-180天',
    day365: '181-365天',
    day730: '366-730天',
    day99999: '730天以上',
    balanceAmount: '未收金额',
    vesselType: '船舶类型',
    invoiceDateFrom: '发票日期从',
    sequence: '显示顺序',
    //账龄分析查询
    agingAnalysisQuery: '账龄分析查询',
    analysisType: '分析类型',
    department: '部门',
    voyageEndsFrom: '航次结束从',
    voyageEnd: '航次结束',
    area: '地区',
    abandonedInvoiceNo: '废弃发票号',
    invoiceCurrency: '发票币种',
    paymentDate: '收款日期',
    collectionDate: '催收日期',
    tenantReplyDate: '租家回复日期',
    ownerCounterDate: '船东COUNTER日期',
    latestTrackingContent: '最新跟踪内容',
    ownerShip: '自有船/租入船',
    routeName: '航线名称',
    //账龄统计
    agingStatistics: '账龄统计',
    compareWith: '相比',
    displayBefore: '显示前',
    percentage: '百分比',
    month: '月份',
    vesselVoyageStatistics: '船舶航次信息统计',
    //空放燃油统计
    ballastStatistics: '空放燃油统计',
    ballastActualTitle: '实际情况[里程：NM，时间：D，消耗：MT，消耗率：MT/D]',
    ballastEstimateTitle: '测算情况[里程：NM，时间：D，消耗：MT，消耗率：MT/D])',
    ballastDistance: '空放里程',
    ballastTime: '空放时间',
    voyageSpeed: '航行速度',
    heavyFuelCost: '重油消耗',
    heavyFuelCostRatio: '重油消耗率',
    //每周燃油统计
    weeklyFuelStatistics: '每周燃油统计',
    buyDate: '购买日期',
    buyQuantity: '购买量',
    buyPrice: '购买价格',
    marketPrice: '市场价格',
    //实际与测算对比
    actualCompare: '实际与测算对比',
    ballastFuelConsumption: '空载耗油',
    heavyFuelConsumption: '重载耗油',
    portFuelConsumption: '在港耗油',
    totalFuelConsumption: '总耗油',
    actualAvgPrice: '实际平均价格',
    totalFee: '总费用',
    totalFuelFee: '总燃油费用',
    actualHeavyOil: '重油实际',
    actualLightOil: '轻油实际',
    estimateHeavyOil: '重油测算',
    estimateLightOil: '轻油测算',
    differenceValue: '差值',
    heavyOil: '重油',
    lightOil: '轻油',
    actualCost: '实际成本',
    estimateCost: '测算成本',
    ratio: '比率',
    //订单
    orderSatatistics: '订单清单统计',
    orderDate: '订单月份',
    orderStatus: '订单状态',
    orderType: '订单类型',
    estimateDate: '暂估月份',
    newestOrderReceipt: '最新订单暂估万能单',
    newestInvoiceReceipt: '最新发票暂估万能单',
    //Tce
    checkData: '检查数据',
    estimated: '预估航次收益',
    statisticalIncome: '编制营运收入统计表',
    detailedIncome: '编制营运收入明细表',
    tceRevenue: 'TCE/收入统计',
    revenueByType: '船队营运情况（按租船类型分类）',
    revenueByVessels: '船队营运情况（按船舶）',
    revenueTceByNow: '船队经营生产统计(实时统计)',
    tceMgtRptByMonth: '船队经营生产统计(每月锁定)',
    tceMgtRptByNow: '船队营运收入统计(实时统计)',
    opertingTceByMonth: '船队营运收入统计(每月锁定)',
    whetherDays: '空放天是否纳入营运天',
    vesselTypes: '船型部',
    plannedDays: '计划航次是否纳入营运天 ',
    //航次预结算/结算统计报表
    preSettlemenetReport: '航次预结算统计报表',
    settlementReport: '航次结算报告',
    vesselCode: '船舶代码',
    voyageBeginDate: '开始日期(年月日)',
    voyageEndDate: '结束日期(年月日)',
    calenderDays: '日历天',
    preOperatingDays: '预计营运天',
    mooringDay: '停泊天',
    pocPer: 'POC完工比',
    vesselManageCompany: '船舶管理公司',
    operationMode: '经营方式',
    freightVolume: '货运量(吨)',
    turnOverVolume: '周转量(千吨海里)',
    reportVersion: '报告版本',
    voyageFee: '航次费用',
    freightFee: '运费',
    otherFee: '其他杂费',
    charteringCost: '租船成本',
    //tce锁定报表
    tceLockNo: 'TCE锁定编号',
    annualYearTce: '全年测算水平',
    unlockEstTce: '未锁定水平预测',
    annualLockRate: '全年锁定率',
    rangeStartDate: '区间开始时间',
    rangeEndDate: '区间结束时间',
    rangeLockTce: '区间锁定TCE',
    rangeOperationDay: '区间总运营天数',
    rangeLockRate: '区间锁定率',
    lockUser: '锁定人',
    lockTime: '锁定时间',
    fuelProcure: '燃油采购统计',
    reportStatisticsMonitor: '结算报告、预结算报告、测算报考监控表',
    monthVesselVoyageReport: '月度船舶航次信息统计表'
  }
};